<template>
  <div>
    <b-alert
      v-for="communityUpdate in communityUpdates"
      :key="communityUpdate.id"
      show
      dismissible
      variant="light"
      :fade=true
      class="alert-wrapper shadow-sm"
      @dismissed="onDismiss(communityUpdate.id)"
    >
      <h1>{{communityUpdate.title}}</h1>
      <div v-for="textBlock in communityUpdate.textBlocks" :key="textBlock.id" class="alert-content">
        <em>{{textBlock.date | moment("DD.MM.YYYY")}}</em>
        <strong>{{textBlock.title}}</strong>
        <p>{{textBlock.text}}</p>
      </div>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false
    }),
    created () {
      this.getCommunityUpdates()
    },
    methods: {
      async getCommunityUpdates () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('communityUpdates/GET_COMMUNITY_UPDATES').then(res => {
          this.isBusy = false
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.isBusy = false
          this.hasUnknownError = true
          console.error(err)
        })
      },
      onDismiss (id) {
        this.$store.commit('communityUpdates/SET_DISS_MISSED_UPDATES', id)
      }
    },
    computed: {
      ...mapGetters({ communityUpdates: 'communityUpdates/COMMUNIY_UPDATES' })
    }
  }
</script>

<style lang="scss" scoped>
  .alert-wrapper{
    padding: 1rem;
    background: $white;
  }
  .alert-content{

    em, strong{
      display: block;
    }
  }
</style>
